<!--
    描述：报价方保证金
    日期：2022/7/26
    创建人：李家宝
-->
<template>
  <div>
    <p>
      当前报价企业数：<span style="color: #0000FF">{{ tableData.length }}</span>
    </p>
    <el-table
      class="mt20"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" align="center" width="70">
      </el-table-column>
      <el-table-column
        prop="providerName"
        align="center"
        label="报价出租方"
        show-overflow-tooltip
        width="180"
      >
      </el-table-column>
      <el-table-column prop="linkMan" width="100" align="center" label="联系人">
      </el-table-column>
      <el-table-column
        prop="linkPhone"
        width="150"
        align="center"
        label="联系方式"
      >
      </el-table-column>
      <el-table-column
        prop="providerTypeName"
        width="100"
        align="center"
        label="类型"
      >
      </el-table-column>
      <el-table-column
        prop="quotationDate"
        width="150"
        align="center"
        label="报价时间"
      >
      </el-table-column>
      <el-table-column
        prop="quotationMoney"
        width="140"
        align="center"
        label="报价金额"
      >
      </el-table-column>
      <el-table-column
        prop="marginAmount"
        width="140"
        align="center"
        label="报价保证金"
      >
      </el-table-column>
      <el-table-column
        prop="remarks"
        min-width="200"
        align="center"
        label="报价备注"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="statusName"
        width="100"
        align="center"
        label="报价状态"
      >
      </el-table-column>
      <el-table-column
        prop="marginAmountStatusName"
        width="100"
        align="center"
        label="保证金状态"
      >
      </el-table-column>
      <el-table-column width="150" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="scope.row.marginAmountStatus == 0"
            type="primary"
            @click="refundMargin(scope.row)"
            >退还保证金
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="退还保证金"
      :visible.sync="dialogVisible"
      top="10vh"
      center
      width="30%"
    >
      <h3>{{ rowData.sname }}</h3>
      <el-row class="mt10">
        <el-col :span="12">报价状态：{{ currentData.statusName }}</el-col>
        <el-col :span="12">保证金：{{ currentData.marginAmount }}</el-col>
      </el-row>
      <p class="mt10">
        请确定退还该项目的投标保证金，确定后保证金将按原路退还。
      </p>
      <!-- footer 组件 -->
      <div slot="footer" class="dialog-footer text-center">
        <el-button size="small" class="btn" @click="dialogVisible = false"
          >取 消
        </el-button>
        <el-button
          type="primary"
          size="small"
          class="btn btn-blue"
          :loading="btnLoading"
          @click="determine"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  zulinselectLessorQuotationInfo,
  refundApply
} from "api/modules/projectManagement";
import { mapState } from "vuex";
export default {
  name: "bidder-margin",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.userInfo
    })
  },
  data() {
    return {
      tableData: [], // 表格数据
      dialogVisible: false, // 对话框
      currentData: {}, //  当前数据
      btnLoading: false // 控制确定按钮
    };
  },
  methods: {
    // 保证金列表
    zulinselectLessorQuotationInfo() {
      zulinselectLessorQuotationInfo({
        id: this.rowData.id,
        currentUserId: this.userInfo.id
      }).then(res => {
        if (res.code == 0) {
          this.tableData = res.data;
        }
      });
    },

    // 退还保证金
    refundApply() {
      refundApply({
        id: this.currentData.id,
        currentUserId: this.userInfo.id,
        userId: this.userInfo.id
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            showClose: true,
            message: res.msg
          });
          this.btnLoading = false;
          this.dialogVisible = false;
          this.zulinselectLessorQuotationInfo();
        }
      });
    },

    // 退还保证金
    refundMargin(row) {
      this.dialogVisible = true;
      this.currentData = row;
      console.log(row);
    },

    // 确定退还
    determine() {
      this.btnLoading = true;
      this.refundApply();
    }
  },

  created() {
    this.zulinselectLessorQuotationInfo();
  },

  mounted() {}
};
</script>

<style scoped></style>
